angular.module("app").controller("PagesEditPageController", [
    '$scope',
    '$stateParams',
    'pagesService',
    'pageStatuses',
    'pageTypes',
    'preloadedPageData',
    'preloadedPages',
    '$timeout',
    'errorHandler',
    'logger',
    '$state',
    'cropperService',
    'settingsService',
    'deepCompare',
    'userStorage',
    'pagination',
    'categoryService',
    'sidebarService',
    function ($scope, $stateParams, pagesService, pageStatuses, pageTypes, preloadedPageData, preloadedPages, $timeout, errorHandler, logger, $state, cropperService, settingsService, deepCompare, userStorage, pagination, categoryService, sidebarService) {
        var pendingListRequest;
        preloadedPageData.page.meta_keywords = preloadedPageData.page.meta_keywords || "";
        preloadedPageData.page.meta_description = preloadedPageData.page.meta_description || "";
        $scope.draggedImageDataUrl = "";
        $scope.settings = settingsService.getSettings();
        $scope.actualPageNames = [];
        $scope.actualStatuses = [
            {
                title: 'all',
                value: undefined
            },
            {
                title: 'actual',
                value: true
            },
            {
                title: 'notActual',
                value: false
            }
        ];

        pagesService.getPagesNames({pageType: preloadedPageData.page.type}).then(
            function (response) {
                if (response.status == "ok") {
                    $scope.actualPageNames =  angular.copy(response.pageNames);
                } else {
                    errorHandler(response.message);
                }
            },
            function (error) {
                errorHandler(error.message);
            }
        );

        $scope.userData = userStorage.getUserData();
        $scope.pagination = pagination.init(function () {
                pendingListRequest && $timeout.cancel(pendingListRequest);
                pendingListRequest = $timeout(function () {
                    var requestData = {
                        current_page: $scope.pagination.page,
                        limit: $scope.pagination.limit
                    };
                    !!$scope.categoryOptions.categories && (requestData.category_id = $scope.categoryOptions.categories);
                    $scope.updateList(requestData)
                }, 300)
            }, preloadedPageData.total_count);

        $scope.state = $state;
        $scope.tabOptions = {
            showMain: $stateParams.showMain,
            hasItems: $stateParams.hasItems
        };
        $scope.$stateParams = $stateParams;
        $scope.pageStatuses = pageStatuses;
        $scope.filterOptions = {
            status: $scope.pageStatuses[0],
            actualStatus: undefined
        };
        $scope.pageTypes = pageTypes;
        $scope.allPages = angular.copy(preloadedPages.pages);
        $scope.pristinePageData = angular.copy(preloadedPageData.page) || {};
        $scope.pageData = angular.copy(preloadedPageData.page) || {};
        !$scope.pageData.customFields && ($scope.pageData.customFields = {
            parent: true,
            children: [

            ]
        });

        $scope.items = angular.copy(preloadedPageData.items) || {};

        $scope.vm = {
            dateTimeFrom: $scope.pageData.start_date || "",
            dateTimeTo: $scope.pageData.end_date || ""
        };

        $scope.categoryOptions = {
            page_id: $scope.pageData.categoryPageId,
            categories: ""
        };

        if ($scope.pageData.type == "news") {
            pagesService.getCategories({lang: preloadedPageData.page.lang, type: "category"}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.allCategories = angular.copy(response.pages);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );
        }

        $scope.handleChangeOfCategory = function (pageId) {
            if (!!pageId) {
                return pagesService.groupCategory({page_id: pageId}).then(
                    function (response) {
                        if (response.status == "ok") {
                            $scope.categoryItems = angular.copy(response.items);
                            $scope.categoryOptions.categories = ($scope.categoryItems && $scope.categoryItems.length) ? $scope.categoryItems[0].id : "";
                            $scope.handleCategoryChange($scope.categoryOptions.categories)
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            }
            $scope.categoryOptions.categories = "";
            $scope.handleCategoryChange();
        };

        $scope.handleCategoryChange = function (categoryId) {
            if (categoryId) {
                return $scope.updateList({category_id: categoryId})
            }
            $scope.updateList()
        };

        $scope.handleChangeOfSetToAllLanguagesBox = function (isEnabled) {
            if (!isEnabled) {
                $scope.pageData.lang = $scope.pageData.lang || $scope.settings.skin.defaultLang || $scope.settings.skin.languages[0];
            }
        };

        $scope.handleChangeOfPageType = function (type) {
            pagesService.getPagesNames({pageType: type}).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.actualPageNames = angular.copy(response.pageNames);
                        $scope.pageData.name = $scope.actualPageNames[0].name
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )

        };

        $scope.updateList = function (externalOptions) {
            var requestObject = {
                page_id: $stateParams.pageId,
                status: $scope.filterOptions.status,
                limit: $scope.pagination.limit
            };
            if ($scope.pageData.type === 'news' && $scope.pageData.setActualBlock) {
                angular.isDefined($scope.filterOptions.actualStatus) && (requestObject.actual = $scope.filterOptions.actualStatus)
            }
            if (externalOptions) {
                angular.extend(requestObject, externalOptions)
            }
            pagesService.getPageItems(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.items = angular.copy(response.items);
                        $scope.pagination.totalItems = response.total_count;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.submitEditPageForm = function () {
            $scope.preview(function (dataUrl) {
                delete $scope.pageData.forceTOChange;
                var requestObj = {
                        page: $scope.pageData
                    },
                    changes;


                if (dataUrl != $scope.draggedImageDataUrl) {
                    if (!$scope.draggedImageDataUrl && !dataUrl && !!requestObj.page.image) {
                        requestObj.page.image = dataUrl || requestObj.page.image;
                    } else {
                        requestObj.page.image = dataUrl || "";
                    }
                }

                if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl) {
                    delete requestObj.page.image;
                    requestObj.page.media_id = $scope.imageToLoad.id
                }

                !!$scope.vm.fromDate ? (requestObj.page.start_date = $scope.vm.fromDate) : ($scope.fromDateChanged && (requestObj.page.start_date = false));
                !!$scope.vm.toDate ? (requestObj.page.end_date = $scope.vm.toDate) : ($scope.toDateChanged && (requestObj.page.end_date = false));
                changes = deepCompare.getChanges(angular.copy(preloadedPageData.page), requestObj.page, false, {});

                if (!angular.equals(changes.customFields, requestObj.page.customFields)) {
                    changes.customFields = requestObj.page.customFields
                }
                changes.id = requestObj.page.id;

                !requestObj.page.global && (delete changes.global);

                $scope.userData.role === 'skin_news_manager' && delete changes.name;

                pagesService.update({page: changes}).then(
                    function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("Page has been successfully updated");
                            preloadedPageData.page = angular.copy($scope.pageData);
                        }
                        else {
                            errorHandler(response.message)
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    }
                );
            });
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.fromDateChanged = true;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.pageData.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.toDateChanged = true;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.pageData.end_date = $scope.vm.toDate;
            }
        };

        $scope.editItem = function (item) {
            $state.go("main.pages.editItem", {pageId: $stateParams.pageId, itemId: item.id})
        };

        $scope.editPage = function (page, hasItems) {
            $state.go("main.pages.editDetailed", {
                pageId: page.id,
                showMain: false,
                hasItems: !!hasItems
            }, {reload: true});
        };

        $scope.deleteItem = function (page) {
            var index = $scope.items.indexOf(page);
            pagesService.deleteItem(page, $stateParams.pageId).then(
                function (response) {
                    if (response.status == "ok") {
                        index != -1 && $scope.items.splice(index, 1);
                        logger.logSuccess("global.itemArchived");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.publishItem = function (page) {
            var index = $scope.items.indexOf(page);
            pagesService.publishItem(page, $stateParams.pageId).then(
                function (response) {
                    if (response.status == "ok") {
                        index != -1 && $scope.items.splice(index, 1);
                        logger.logSuccess("global.itemPublished");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.checkUserRole = function () {
            return $scope.userData.role !== 'skin_news_manager'
        };

        $scope.getChanges = function () {
            if ($scope.newImageUploaded) {
                return false
            }
            return deepCompare.isEqual($scope.pageData, angular.copy(preloadedPageData.page));
        };

        $scope.allowUpdate = function (options) {
            if (options && options.autoUpdate) {
                reorder();
            } else if (!!options) {
                $scope.tabOptions.reordered = true
            }
        };

        function reorder () {
            if (typeof $scope.items === "object" && $scope.items.length) {
                var list = [];
                $scope.items.forEach(function (item) {
                    list.push(item.id);
                });

                $scope.pageData.type === 'sidebar' && reorderByService(list, sidebarService);
                $scope.pageData.type === 'category' && reorderByService(list, categoryService);
                $scope.pageData.type === 'text' && reorderByService(list, pagesService);
            }
        }

        function reorderByService (list, service) {
            service.changeOrder({order: list}).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.updated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        cropperService.call($scope);
    }
]);